import { useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SectionOneBackground from "../../assets/Icons/SectionOneBackground.svg";
const useDemoPageStyles = makeStyles(() => {
  return {
    loginBtn: {
      margin: "0 10px !important",
      width: "200px !important",
    },
    signUpBtn: {
      width: "200px !important",
    },
    mainBox: {
      position: "static",
      width: "100%",
      height: "100%",
      top: "10% !important",
      zIndex: 1,
    },
    mainGrid: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      padding: "50px !important",
      height: "fit-content",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundImage: `url(${SectionOneBackground})`,
      "&.mobile": {
        flexDirection: "column",
        padding: "20px !important",
        marginTop: "30px",
      },
    },
    mainGridSectionOne: {
      marginTop: "7% !important",
      "&.mobile": {
        marginTop: "10% !important",
      },
    },
    sectionOneText: {
      zIndex: 3,
      width: "100%",
    },
    buttonsHolder: {
      display: "flex",
      flexDirection: "row",
      marginTop: "5% !important",
    },
    profitGrid: {
      display: "flex",
      justifyContent: "space-between",
      height: "fit-content",
      textAlign: "center",
      marginTop: "5% !important",

      "&.mobile": {
        marginTop: "10% !important",
      },
    },
    profitIcon: {
      zIndex: 3,
      width: "10%",
      "&.mobile": {
        width: "25%",
      },
    },
    catalogHealthLogo: {
      width: "15%",
      "&.mobile": {
        width: "20%",
      },
    },
    catalogGrid: {
      display: "flex",
      justifyContent: "space-between",
      height: "fit-content",
      textAlign: "center",
      marginTop: "5% !important",

      "&.mobile": {
        marginTop: "0% !important",
      },
    },
    catalogGridHolder: {
      gridGap: "5% !important",
    },
    catalogHealthText: {
      // width: "60%",
      "&.mobile": {
        paddingRight: "10%",
      },
    },
    catalogHealthButton: {
      width: "30%",
      "&.mobile": {
        width: "30%",
      },
    },
    supplyChainGrid: {
      display: "flex",
      justifyContent: "space-between",
      height: "fit-content",
      textAlign: "center",
      marginTop: "5% !important",

      "&.mobile": {
        marginTop: "0% !important",
        flexDirection: "column-reverse",
      },
    },
    sectionOneFooterGrid: {
      textAlign: "center",
      padding: "10px",
      margin: "2% 0% -3% 0%",
    },
    sectionOneFooter: {
      width: "80%",
    },
    sectionOneFooterText: {
      fontFamily: "Lato !important",
      fontSize: "42px !important",
      fontWeight: "300 !important",
      lineHeight: "46px !important",
      color: "#FF6C37 !important",
      "&.mobile": {
        flexDirection: "row",
        fontSize: "28px !important",
      },
    },
    sectionOneFooterTextBreak: {
      fontWeight: "700",
      "&.mobile": {
        display: "block !important",
      },
    },
    catalogHolder: {
      marginLeft: "50px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      marginTop: "15%",

      "&.mobile": {
        marginLeft: "20px",
      },
    },
    catalogHealthImage: {
      textAlign: "right",
      marginTop: "0%",
      "&.mobile": {
        marginTop: "5%",
      },
    },
    supplyChainImage: {
      textAlign: "left",
      marginTop: "0%",

      "&.mobile": {
        marginTop: "5%",
      },
    },
    supplyChainHolder: {
      marginRight: "30px",
      marginLeft: "0px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      marginTop: "15%",
      "&.mobile": {
        marginLeft: "20px",
      },
    },
    bussinessGrowth: {
      marginLeft: "50px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      marginTop: "15%",
      "&.mobile": {
        marginLeft: "20px",
      },
    },
    bussinessGrowthImage: {
      textAlign: "right",
      marginTop: "0%",
      "&.mobile": {
        marginTop: "5%",
      },
    },
    sellerAccountImage: {
      textAlign: "left",
      marginTop: "0%",
      "&.mobile": {
        marginTop: "5%",
        textAlign: "center",
      },
    },
    sellerAccountHolder: {
      marginRight: "30px",
      marginLeft: "0px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      marginTop: "15%",
      "&.mobile": {
        marginLeft: "20px",
      },
    },

    sectionOneImage: {
      zIndex: 2,
      width: "100%",
      marginTop: "30px",
      "&.mobile": {
        marginTop: "0px",
      },
    },
    catalogHealthImageStyle: {
      zIndex: 2,
      width: "80%",

      "&.mobile": {
        width: "90%",
      },
    },
    supplyChainImageStyle: {},
    amazonSellerAccounts: {
      fontFamily: "Lato !important",
      fontSize: "48px !important",
      fontWeight: "300 !important",
      lineHeight: "58px !important",
      textAlign: "left",
      color: "white !important",
      "&.mobile": {
        fontSize: "32px !important",
        lineHeight: "40px !important",
      },
    },
    wordBold: {
      fontWeight: "700 !important",
    },
    exploreText: {
      fontWeight: "700 !important",
      display: "block",
    },
    ridgewoodSeller: {
      fontFamily: "Lato !important",
      fontSize: "26px !important",
      fontWeight: "300 !important",
      lineHeight: "36px !important",
      textAlign: "left",
      color: "#7DC8FD !important",
      marginTop: "5% !important",
    },
    profitTextIncrease: {
      fontFamily: "Lato !important",
      fontSize: "48px !important",
      fontWeight: "700 !important",
      lineHeight: "56px !important",
      textAlign: "center",

      color: "#1976D2 !important",
      "&.mobile": {
        fontSize: "32px !important",
        lineHeight: "36px !important",
      },
    },
    profitTextTasks: {
      fontWeight: "300 !important",
      fontSize: "40px !important",
      display: "block !important",
      "&.mobile": {
        fontSize: "28px !important",
      },
    },
    catalogTextImprove: {
      fontFamily: "Lato !important",
      fontSize: "42px !important",
      fontWeight: "700 !important",
      lineHeight: "56px !important",
      textAlign: "left",

      color: "#1976D2 !important",
      "&.mobile": {
        fontSize: "28px !important",
        lineHeight: "46px !important",
      },
    },
    catalogTextHealth: {
      fontWeight: "300 !important",
    },
    catalogTextFlag: {
      display: "block",
      fontFamily: "Lato !important",
      fontSize: "26px !important",
      fontWeight: "400 !important",
      lineHeight: "36px !important",
      textAlign: "left",
      color: "#333333 !important",
      "&.mobile": {
        fontSize: "18px !important",
        lineHeight: "26px !important",
      },
    },
    seeDemo: {
      width: "100px !important",
      border: "none !important",
      boxShadow: "none !important",
      padding: "0px !important",
      justifyContent: "left !important",

      "& .MuiTypography-root": {
        whiteSpace: "nowrap !important",
        textDecoration: "underline !important",
      },
      "&.mobile": {
        "& .MuiTypography-root": {
          fontSize: "18px !important",
        },
      },
    },
    getStarted: {
      width: "100px !important",

      "& .MuiTypography-root": {
        fontSize: "15px !important",
        whiteSpace: "nowrap !important",
      },
    },
    amazonRankSales: {
      display: "flex",
      justifyContent: "space-between",
      height: "fit-content",
      textAlign: "center",
      marginTop: "5% !important",
      backgroundColor: "#0275C4 !important",
      "&.mobile": {
        marginTop: "10% !important",
        flexDirection: "column-reverse",
      },
    },
    amazonRankSalesText: {
      fontFamily: "Lato !important",
      fontSize: "32px !important",
      fontWeight: "700 !important",
      lineHeight: "46px !important",
      textAlign: "left",

      color: "#FFFFFF !important",
      "&.mobile": {
        fontSize: "28px !important",
        lineHeight: "46px !important",
      },
    },
    amazonRankSalesTextSeller: {
      display: "block !important",
      fontSize: "28px !important",
      fontWeight: "300 !important",
      lineHeight: "36px !important",
      "&.mobile": {
        fontSize: "28px !important",
        lineHeight: "46px !important",
      },
    },
    amazonRankSalesTextTools: {
      marginTop: "10% !important",
      display: "block !important",
      fontSize: "18px !important",
      fontWeight: "400 !important",
      lineHeight: "26px !important",

      "&.mobile": {
        fontSize: "28px !important",
        lineHeight: "46px !important",
      },
    },

    catalogHealthImageStyles: {
      zIndex: 2,
      width: "70%",
      marginTop: "8% !important",
      "&.mobile": {
        width: "80%",
      },
    },

    trophyStyle: {
      zIndex: 2,
      width: "60%",
      margin: "5%  0 7% 5% ",
      "&.mobile": {
        width: "80%",
      },
    },

    sectionOneGrid: {
      marginTop: "2%",
      "&.mobile": {
        marginTop: "10%",
      },
    },
    profitGridStyle: {
      marginTop: "2%",
      "&.mobile": {
        marginTop: "10%",
      },
    },
    freeTrialHolder: {
      display: "flex",

      justifyContent: "center",
      marginTop: "3%",
      "&.mobile": {
        marginTop: "5%",
      },
    },

    monthFree: {
      fontFamily: "Lato !important",
      fontSize: "34px !important",
      fontWeight: "700 !important",
      lineHeight: "24px !important",
      letterSpacing: "0.4000000059604645px",
      color: "#1976D2 !important",
      "&.mobile": {
        fontSize: "14px !important",
      },
    },

    noCreditCard: {
      fontFamily: "Lato !important",
      fontSize: "34px !important",
      fontWeight: "300 !important",
      lineHeight: "24px !important",
      letterSpacing: "0.4000000059604645px",
      color: "#1976D2 !important",
      "&.mobile": {
        fontSize: "14px !important",
      },
    },
    greyBackground: {
      backgroundColor: "#DCE3EB !important",
      paddingBottom: "3%",
    },
    tryButton: {
      width: "200px",
    },
    productsBoxGrid: {
      position: "static",
    },
    freeButtonGrid: {
      textAlign: "center",
      marginTop: "-40px !important",
      "&.mobile": {
        marginTop: "0px !important",
      },
    },
    video: {
      height: "100% !important",
      width: "100% !important",
      overflow: "hidden !important",
      borderRadius: "8px !important",
    },
    playBtn: {
      background: "transparent !important",
      position: "absolute",
      zIndex: 1,
      width: "150px !important",
      filter:
        "invert(33%) sepia(85%) saturate(6797%) hue-rotate(196deg) brightness(53%) contrast(90%) !important",
      "&.mobile": {
        width: "100px !important",
      },
    },
    thumbnail: {
      overflow: "hidden !important",
    },
    videoMainGrid: {
      boxShadow: "10px 10px 15px grey, -10px 10px 15px grey, 0 10px 15px grey",
    },
    videoOuterGrid: {
      marginTop: "5% !important",
      "&.mobile": {
        marginTop: "15% !important",
      },
    },
    demoVideoBox: {
      width: "100% !important",
      height: "10px !important",
    },
  };
});

export default useDemoPageStyles;
